function getConversationOpk(url) {
  return url.match(/conversations\/([a-zA-z0-9]+)\/$/)[1] || {};
}

export default getConversationOpk;



// WEBPACK FOOTER //
// ../utilities/conversation.js